export default __webpack_public_path__ + "static/1619-dca717ea9bab9cbc86b99da808cd404b.gif";